import { type ReactNode } from 'react';

import styles from './TagGroup.module.css';

export function TagAvatar(props: { children: ReactNode }) {
  return <span {...props} className={styles.avatar} />;
}
